import { Type } from "@themes/pollinator/ui/Type";

export type Props = {
  speaker: string;
  text: string;
};

export function VideoUISubtitleItem({ speaker, text }: Props) {
  return (
    <div className="bg-brand-950/80 text-brand-50 px-4 py-2 text-left flex flex-row items-start gap-2 w-max rounded-md max-w-full">
      {speaker && (
        <Type variant="body2" className="flex-shrink-0 md:relative md:top-1">
          [{speaker}:]
        </Type>
      )}
      <Type variant="body1" className="max-w-auto">
        {text}
      </Type>
    </div>
  );
}

export default VideoUISubtitleItem;
